import {
  Box,
  ColumnLayout,
  Container,
  Header,
  Link,
  SpaceBetween
} from '@amzn/awsui-components-react/polaris';
import { useNavigate } from 'react-router-dom';

interface Tool {
  name: string;
  description: string;
  href: string;
}

const TOOLS: Tool[] = [
  {
    name: 'General Map Viewer',
    description: 'View and explore maps with various tile sources',
    href: '/general-map-viewer'
  },
  {
    name: 'Map Viewer - Compare',
    description: 'Compare two map sources side by side',
    href: '/general-map-viewer-compare'
  },
  {
    name: 'Tile Validation Metrics',
    description: 'View tile validation and quality metrics',
    href: '/tile-validation-metrics'
  },
  {
    name: 'Map Release Dashboard',
    description: 'Monitor map release status and workflows',
    href: '/map-release-dashboard'
  }
];

const ToolsPanel = () => {
  const navigate = useNavigate();

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Quick access to commonly used tools"
        >
          Tools
        </Header>
      }
    >
      <ColumnLayout columns={4} variant="text-grid">
        {TOOLS.map((tool) => (
          <SpaceBetween key={tool.href} size="xxs">
            <Box variant="h4">
              <Link
                onFollow={(event) => {
                  event.preventDefault();
                  navigate(tool.href);
                }}
                href={tool.href}
              >
                {tool.name}
              </Link>
            </Box>
            <Box variant="small" color="text-body-secondary">
              {tool.description}
            </Box>
          </SpaceBetween>
        ))}
      </ColumnLayout>
    </Container>
  );
};

export default ToolsPanel;
